<template>
  <div class="dlnkforums_component w-100">

    <div class="mb-4 border-bottom">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h3 class="mb-0">Derniers messages du forum</h3>
      </div>

      <!-- Blog -->
      <article class="pb-3 mb-2"
               v-for="post in posts"
               :key="post.id">
        <div class="media align-items-center text-inherit">
          <div class="media-body row">
									<span class="col-12 font-size-1 text-dark">
								    	<strong>{{ post.topic.title }}</strong>
								    </span>
            <span class="col-10 font-size-1 text-body">
              <strong>{{ post.author.firstname }}</strong> : <span v-html="post.message.substring(0, 100)"></span>
            </span>
            <span class="col-2 pl-0 font-size-1 text-body text-md-right">
              <strong>{{ date_post(post.created_at) }}</strong>
            </span>
          </div>
        </div>
      </article>
      <!-- End Blog -->

    </div>

  </div>
</template>"

<script>

export default {
  props: [
    'customer_id',
    'group_id',
    'group_status',
    'base_url',
  ],
  data: function () {
    return {
      timer: null,
      posts: [],
      query: '',
      message: '',
    }
  },
  mounted() {
    this.get_posts()
    this.timer = setInterval(this.get_posts, 5000);
  },

  beforeDestroy () {
    clearInterval(this.timer);
  },

  computed: {
    submit_disabled: function () {
      return false;
    }
  },

  methods: {


    date_post: function (str_date) {
      const date_post = new Date(str_date);
      return date_post.getDate() + '/' + date_post.getMonth() + '/' +
          date_post.getFullYear();

    },

    get_posts: async function () {
      const _this = this;
      let api_url = this.base_url + "posts.json?limit=10";

      const secure_key = await get_token();
      api_url += '&secure_key=' + secure_key;
      api_url += '&customer_id=' + this.customer_id;


      if (_this.group_id > 0) {
        api_url = api_url + "&group_id=" + _this.group_id;
      }

      axios.get(api_url)
          .then(function (response) {
            _this.posts = response.data
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}
</script>
